import { defineStore } from 'pinia'
import httpClient from '@/api/httpClient'
import { xor } from 'lodash'

import { getDefaultPaginationState } from '@/stores/shared/pagination'

export const useMediaSelectingStore = defineStore('mediaSelecting', {
  state: () => ({
    ...getDefaultPaginationState(),
    show: false,
    mediumIds: [],
    searchResults: {}
  }),

  getters: {
    selected({ media, selectedMediaIds }) {
      return media.filter((medium) => selectedMediaIds.includes(medium.id) )
    }
  },

  actions: {
    toggle(mediumId) {
      this.mediumIds = xor(this.mediumIds, [mediumId])
    },

    async search({ search, page, perPage, filterTypes }) {
      this.mediumIds = []

      return httpClient.get('/api/internal/media', {
        params: { search, page, per_page: perPage, types: filterTypes }
      }).then(({ data: { media, meta: { page }} }) => {
        this.searchResults = media
        this.page = page
      })
    }
  }
})
